import { Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import {
  HasRowColor,
  OutputLayoutFieldWithDetails,
  asFieldsWithDimensionsContainer,
} from '@ssar-app/domain';
import { CSSProperties } from 'react';

export interface ScoreDistributionReportProps {
  programName?: string;
  scoreDistributionFieldsWithDetailsAndRowColor: HasRowColor<OutputLayoutFieldWithDetails>[];
}
export const ScoreDistributionReport = (
  props: ScoreDistributionReportProps,
) => {
  const dataWithFieldDimensions = asFieldsWithDimensionsContainer(
    props.scoreDistributionFieldsWithDetailsAndRowColor || [],
  ).fields;

  const borderStyles: CSSProperties = {
    textAlign: 'center',
    border: '1px solid rgba(29,79,145, .3)',
  };

  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={8}
        marginBottom={2}
        fontSize={'sm'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Attributes Selected for Reports
      </Heading>
      {dataWithFieldDimensions.length > 0 ? (
        <Grid templateColumns='repeat(9, 1fr)'>
          <GridItem style={{ ...borderStyles }}>
            <strong>Field#</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Source</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Field Name</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Client Header</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Length</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Start</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Description</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Valid Values</strong>
          </GridItem>
          <GridItem style={{ ...borderStyles }}>
            <strong>Default/Exclusion Values</strong>
          </GridItem>
          {dataWithFieldDimensions.map((item, index) => {
            return (
              <>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {index + 1}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.source || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.name || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.headerName || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.fieldLength || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.begin || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.description || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.validValues || ''}
                </GridItem>
                <GridItem
                  style={{ ...borderStyles, backgroundColor: item?.rowColor }}
                >
                  {item?.defaultValues || ''}
                </GridItem>
              </>
            );
          })}
        </Grid>
      ) : (
        <Text>
          No Attributes were selected for Attribute Distribution Reports.
        </Text>
      )}
    </>
  );
};
